import { render, staticRenderFns } from "./info.vue?vue&type=template&id=74b3d7db&scoped=true&"
import script from "./info.vue?vue&type=script&lang=js&"
export * from "./info.vue?vue&type=script&lang=js&"
import style0 from "./info.vue?vue&type=style&index=0&lang=css&"
import style1 from "./info.vue?vue&type=style&index=1&id=74b3d7db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b3d7db",
  null
  
)

export default component.exports